import { StateUtils } from '@spartacus/core';
import {
  B2BPermissionOrderListItem,
  DeliveryAddress,
  ListModel,
  Permission,
  PermissionConnections,
  SoldTo,
} from '../../../core/model';

export const PERMISSION_BASE_FEATURE = 'permissions';
export const ADMIN_PERMISSION_FEATURE = 'permission-admin';
export const BUYER_PERMISSION_FEATURE = 'permission-buyer';
export const PERMISSION_ENTITIES = 'permission-entities';
export const PERMISSION_BUYER_ENTITIES = 'permission-buyer-entities';
export const PERMISSION_CONTACT_PERSON = 'permission-contact-person';
export const PERMISSION_LIST = 'permission-list';
export const PERMISSION_ORDERS_LIST = 'permission-orders-list';
export const PERMISSION_ORDERS_ENTITIES = 'permission-orders-entities';
export const PERMISSION_FILTER_SOLDTOS_LIST = 'permission-filter-soldtos-list';
export const PERMISSION_FILTER_SOLDTOS_ENTITIES = 'permission-filter-soldtos-entities';
export const PERMISSION_FILTER_SHIPTOS_LIST = 'permission-filter-shiptos-list';
export const PERMISSION_FILTER_SHIPTOS_ENTITIES = 'permission-filter-shiptos-entities';
export const PERMISSION_BUYER_LIST = 'permission-buyer-list';
export const PERMISSION_BUYER_ORDERS_LIST = 'permission-buyer-orders-list';
export const PERMISSION_BUYER_ORDERS_ENTITIES = 'permission-buyer-orders-entities';
export const PERMISSION_USERS = 'permission-users';
export const PERMISSION_CONNECTIONS_LIST = 'permission-connections-list';
export const PERMISSION_CONNECTIONS_UPDATE = 'permission-connections-update';
export const PERMISSION_CREATE = 'permission-create';
export const PERMISSION_DELETE = 'permission-delete';
export const PERMISSION_PUBLISH = 'permission-publish';
export const PERMISSION_UNPUBLISH = 'permission-unpublish';

export interface StateWithPermission {
  [PERMISSION_BASE_FEATURE]: PermissionBaseFeatureState;
}

export interface PermissionBaseFeatureState {
  [ADMIN_PERMISSION_FEATURE]: PermissionManagement;
  [BUYER_PERMISSION_FEATURE]: BuyerPermissionManagement;
}

export interface Management<Type> extends StateUtils.EntityListState<Type> {}

export interface PermissionManagement extends Management<Permission> {
  create: StateUtils.LoaderState<Permission>;
  delete: StateUtils.LoaderState<string>;
  updatePermissionContactPerson: StateUtils.LoaderState<string>;
  publish: StateUtils.LoaderState<string>;
  unpublish: StateUtils.LoaderState<string>;
  connections: {
    list: StateUtils.LoaderState<PermissionConnections>;
    update: StateUtils.LoaderState<PermissionConnections>;
  };
  orders: StateUtils.EntityListState<B2BPermissionOrderListItem>;
  filter: {
    soldTos: StateUtils.EntityListState<SoldTo>;
    shipTos: StateUtils.EntityListState<DeliveryAddress>;
  };
}

export interface BuyerPermissionManagement extends Management<Permission> {
  orders: {
    list: StateUtils.EntityLoaderState<ListModel>;
    entities: StateUtils.EntityLoaderState<B2BPermissionOrderListItem>;
  };
}
